import { render, staticRenderFns } from "./AnchorPanel.vue?vue&type=template&id=ded03bf2&scoped=true"
import script from "./AnchorPanel.vue?vue&type=script&lang=js"
export * from "./AnchorPanel.vue?vue&type=script&lang=js"
import style0 from "./AnchorPanel.vue?vue&type=style&index=0&id=ded03bf2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded03bf2",
  null
  
)

export default component.exports